<template>
<div class="as-container">
  <section>
    <div class="as-body section">
      <input class="as-input input" name="username" v-model="username" placeholder="username"/>
      <br>
      <br>
      <input class="as-input input" type="password" v-model="password" placeholder="password"/>
      <br>
      <br>
      <br>
      <button class="as-btn as-btn--l" @click="authentify">Entrer</button>
    </div>
  </section>
</div>
</template>

<script>
// import axios from 'axios'
export default {
  data () {
    return {
      username: ``,
      password: ``
    }
  },
  methods: {
    async authentify () {
      if (process.env.VUE_APP_USER === this.username && process.env.VUE_APP_PSWD === this.password) {
        this.$emit('authentify', true)
      } else {
        alert('bad credentials')
      }
    }
  }
}
</script>

<style>
.input {
  width: 25rem !important;
}

.section {
  padding-top: 12.5rem;
}
.as-btn--l {
    padding: 8px 16px;
    font: 20px/28px var(--as--font-family--base);
    background: #FEC503 !important;
    color:black !important;
}
</style>
